/* eslint-disable no-unused-vars */
import { Suspense } from "react";
import { Outlet, Navigate } from "react-router-dom";
import SplashLoader from "../../components/ui/loader";
import { useAuth } from "../../controllers/auth";

const PublicRoutes = () => {
  const { authenticated } = useAuth();
  return !authenticated ? (
    <Suspense fallback={<SplashLoader />}>
      <Outlet />
    </Suspense>
  ) : (
    <Navigate to={`/dashboard`} />
  );
};

export default PublicRoutes;
